import React from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { CASINO_VIDEO_URL } from '../utils/constants';

export default function CasinoIframe() {
    const location=useLocation();
    const prams=useParams()
    var GAME_ID =prams?.id

  return (
    <iframe style={{height:"430px", width:"100%"}} src={CASINO_VIDEO_URL+GAME_ID}/>
  )
}
 